<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<!-- 头部 -->
		<div class="backView">
			<div class="backViewL">申请物料</div>
			<div class="backViewR">
				<el-button size="small" @click="$router.go(-1)">返回</el-button>
			</div>
		</div>

		<!-- 表格 -->
		<div class="tableView">
			<el-table :data="tableData" style="width: 100%">
				<el-table-column prop="name" label="名称">
				</el-table-column>
				<el-table-column prop="brand" label="品牌">
				</el-table-column>
				<el-table-column prop="unit" label="单位">
				</el-table-column>
				<el-table-column prop="categoryInfo.name" label="分类">
				</el-table-column>
				<el-table-column prop="num" label="数量">
					<template slot-scope="scope">
						<el-input-number v-model="scope.row.num" :min="1" label="描述文字" size="small"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column label="备注">
					<template slot-scope="scope">
						<el-input type="text" v-model="scope.row.remark" size="small" placeholder="请输入备注"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="60">
					<template slot-scope="scope">
						<el-button @click="handleDeleteClick(scope.$index)" type="text" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 底部按钮 -->
		<div class="btnView">
			<div class="btnViewL">
				<div class="btnViewFlex">
					<div>期望到货日期:</div>
					<el-date-picker :picker-options="pickerOptions" value-format='timestamp' v-model="dateValue"
						type="date" placeholder="选择日期" size="small" style="width: 200px;">
					</el-date-picker>
				</div>
				<div class="btnViewFlex">
					<div>备注:</div>
					<el-input v-model="remark" placeholder="请输入备注" size="small" style="width: 200px;"></el-input>
				</div>
			</div>
			<div class="btnViewR">
				<el-button size="small" @click="drawerTianjiawuliao_state = true">添加物料</el-button>
				<el-button size="small" type="warning" @click="handleSaveClick">保存</el-button>
				<el-button size="small" @click="hanleApproveClick">提交审批</el-button>
			</div>
		</div>

		<!-- 添加物料弹框 -->
		<div v-if="drawerTianjiawuliao_state">
			<drawerTianjiawuliao @closeOn="handleDrawerClose" :xinzengkehuState="drawerTianjiawuliao_state"
				@submit="handleUpdateWuliao"></drawerTianjiawuliao>
		</div>
	</div>
</template>

<script>
	import drawerTianjiawuliao from "../drawer/drawerTianjiawuliao.vue"
	export default {
		components: {
			drawerTianjiawuliao
		},
		data() {
			return {
				fixedHeight: '',
				pickerOptions: {
					disabledDate(time) {
						//如果没有后面的-8.64e7就是不可以选择今天的 
						return time.getTime() < Date.now() - 8.64e7;
					}
				},
				remark: '', //备注
				dateValue: '', //期望到货日期
				tableData: [], //表格
				drawerTianjiawuliao_state: false, //添加物料弹框
				orderId:'',
				navId:'',  //编辑跳转id
			}
		},
		created() {
			this.fixedHeight = document.documentElement.clientHeight - 76;
		},
		mounted() {
			if(this.$route.query.id != undefined){
				console.log('编辑')
				this.navId = this.$route.query.id;
				this.getDetailData()
			}
		},
		methods: {
			//获取表格数据
			getDetailData(){
				let params = {
					orderId:this.navId
				}
				this.$http.get(process.env.VUE_APP_Url_8022 + '/api/PurchaseApply/info',params).then(
					res => {
						if (res.code == 0) {
							console.log('详情',res.data)
							let detailData = res.data;
							detailData.orderItems.map(item=>{
								let obj = {
									brand:item.brand,
									categoryInfo:item.categoryInfo,
									name:item.materialName,
									remark:item.remark,
									id:item.materialId,
									num:item.applyCount,
									unit:item.unit
								}
								this.tableData.push(obj)
							})
							this.remark = detailData.remark;
							this.dateValue = new Date(detailData.applyTime).getTime();
							this.orderId = detailData.id;
						}
					})
			},
			//提交审批
			hanleApproveClick(){
				if (this.tableData.length == 0) {
					this.$message({
						type: 'error',
						message: '请添加物料'
					})
					return
				}
				if (this.dateValue == '') {
					this.$message({
						type: 'error',
						message: '请选择期望到货日期'
					})
					return
				}
				let params = {
					orderId:this.orderId,
					expectArriveTime:this.dateValue/1000,
					remark: this.remark,
					items:[]
				}
				
				this.tableData.map(item=>{
					params.items.push({
						materialId:item.id,
						count:item.num,
						remark:item.remark
					})
				})
				console.log(params)
				this.$http.post(process.env.VUE_APP_Url_8022 + '/api/PurchaseApply/Update',params).then(
					res => {
						if (res.code == 0) {
							console.log(res.data)
							this.$http.get(process.env.VUE_APP_Url_8022 + '/api/PurchaseApply/send/Approve',{id:res.data}).then(
								res => {
									if (res.code == 0) {
										this.$message({
											type: 'success',
											message: '已提交'
										});
										this.$router.go(-1)
									}
								})
						}
					})
			},
			//保存
			handleSaveClick() {
				console.log(this.tableData)
				if (this.tableData.length == 0) {
					this.$message({
						type: 'error',
						message: '请添加物料'
					})
					return
				}
				if (this.dateValue == '') {
					this.$message({
						type: 'error',
						message: '请选择期望到货日期'
					})
					return
				}
				this.$confirm('是否确认保存?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						orderId:this.orderId,
						expectArriveTime:this.dateValue/1000,
						remark: this.remark,
						items:[]
					}
					
					this.tableData.map(item=>{
						params.items.push({
							materialId:item.id,
							count:item.num,
							remark:item.remark
						})
					})
					console.log(params)
					this.$http.post(process.env.VUE_APP_Url_8022 + '/api/PurchaseApply/Update',params).then(
						res => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: '已保存'
								});
								this.$router.go(-1)
							}
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消保存'
					});
				});
			},
			//删除物料
			handleDeleteClick(index) {
				// console.log(index)
				this.tableData.splice(index, 1);
			},
			//选择物料
			handleUpdateWuliao(val) {
				// console.log('物料',val,this.tableData)
				let table = this.tableData;
				for (let i = 0; i < table.length; i++) {
					// console.log(table[i].id)
					if (table[i].id == val.id) {
						this.$message({
							message: '该商品已添加',
							type: 'error'
						});
						return
					}
				}
				table.push(val)
			},
			//关闭弹框
			handleDrawerClose(val) {
				console.log('关闭', val)
			},
		},
	}
</script>

<style lang="scss" scoped>
	.page {
		display: flex;
		flex-direction: column;

		.backView {
			height: 62px;
			border-radius: 10px;
			background: #fff;
			display: flex;
			align-items: center;
			padding: 0 20px;
			justify-content: space-between;
			margin-bottom: 16px;

			.backViewL {
				font-size: 20px;
				font-weight: bold;
			}
		}

		.tableView {
			flex: 1;
			background: #fff;
			overflow-y: scroll;
		}

		.tableView::-webkit-scrollbar {
			display: none;
		}

		.btnView {
			height: 62px;
			background: #fff;
			box-shadow: 0px -3px 10px 0px rgba(245, 136, 42, 0.09);
			display: flex;
			padding: 0 20px;
			justify-content: space-between;
			align-items: center;

			.btnViewL {
				display: flex;
				align-items: center;

				.btnViewFlex {
					display: flex;
					align-items: center;
					margin-right: 10px;

					div:nth-of-type(1) {
						font-size: 14px;
						margin-right: 10px;
						font-weight: bold;
					}
				}
			}
		}
	}
</style>
